import { CrossRefPaper } from '@cpsy-rmap-project/web-core/crossref'
import * as yup from 'yup'

// キーワード（CrossRef検索用）バリデーション
const schemaKeywords = yup.object().shape({
  keywords: yup.string().required().min(3)
})

export const varidateKeywords = (keywords: string) => {
  try {
    schemaKeywords.validateSync({ keywords })
    return []
  } catch (e: any) {
    return e.errors as string[]
  }
}

// Paper登録バリデーション（表示されたい順番と逆にしておく）
const schemaPaper = yup.object().shape({
  url: yup.string().required(),
  year: yup.number().required(),
  authors: yup.string().required(),
  title: yup.string().required()
})
export const varidatePaper = (paper: CrossRefPaper) => {
  try {
    schemaPaper.validateSync(paper)
    return []
  } catch (e: any) {
    return e.errors as string[]
  }
}
